// @flow

import type {TreeStructure} from '../typedef';

export const getDataTotalLength = (data: TreeStructure): number => (
    data.length - data.filter(item => item.transient && !(item.children && item.children.length)).length
);
